import React from "react";
import AddToPlaylistModal from "./AddToPlaylistModal";
import SignUpSuccessModal from "./SignUpSuccessModal";

function ModalContainer() {
  return (
    <div id="modal-root">
      <AddToPlaylistModal />
      <SignUpSuccessModal />
    </div>
  );
}

export default ModalContainer;
